jQuery(document).ready(function ($) {
  /*
   * Hit appointment cancel endpoint when RSP counts out
   */
  // document.addEventListener("rspReachedZero", function (e) {
  //   alert("rspReachedZero:" + child.ui);
  //   $.ajax({
  //     type: "POST",
  //     url: child.ajaxurl,
  //     dataType: "json",
  //     data: {
  //       action: "beeep",
  //       nonce: child.nonce,
  //       ui: child.ui,
  //     },
  //   })
  //     .done(function (data) {
  //       console.log("BOOOOOOOP", data);
  //     })
  //     .fail(function (jqXHR, textStatus, errorThrown) {
  //       console.log(jqXHR);
  //       console.log(textStatus);
  //       console.log(errorThrown);
  //     })
  //     .always(function () {
  //       //
  //     });
  // });
  /**
   * Generate Category Links
   */
  const shop_categories = $(".shop-category-head");
  if (shop_categories.length) {
    $("body").addClass("has_categories");
    shop_categories.each(function () {
      const el = $(this);
      const target = el.data("pixel-id");
      const name = el.text();

      $(".category-links").append(
        '<li><a href="#' + target + '">' + name + "</a></li>"
      );
    });
  } else {
    $(".category-nav").hide();
  }

  /**
   * Category links reveal on scroll
   */
  $("body").addClass("revealed");
  var scrollTimeout;
  var throttle = 50;
  var lastScrollTop = 0;
  $(window).scroll(function (event) {
    if (!scrollTimeout) {
      scrollTimeout = setTimeout(function () {
        var st = $(this).scrollTop();
        if (st < lastScrollTop || st <= 15) {
          $("body").addClass("revealed");
        } else {
          $("body").removeClass("revealed");
        }
        lastScrollTop = st;
        scrollTimeout = null;
      }, throttle);
    }
  });

  /**
   * On single products with galleries, set the correct position for max per order string
   */
  function set_max_per_order_position() {
    var product_single_image = $(".woocommerce-product-gallery__image");
    if (product_single_image.length && $(".flex-viewport").length) {
      $(".woocommerce-product-gallery .max-per-order").css(
        "top",
        product_single_image.height()
      );
    }
  }
  setTimeout(function () {
    set_max_per_order_position();
  }, 115);
  window.onresize = function () {
    set_max_per_order_position();
  };
});
